/**
 * Revokes a Google OAuth access token (GIS / Classroom). Best-effort; ignores network errors.
 * Called from sign-out and account deletion so the token stops working on this device.
 */
export async function revokeGoogleOAuthAccessToken(accessToken: string): Promise<void> {
  const t = accessToken.trim();
  if (!t || typeof fetch === 'undefined') return;
  try {
    await fetch('https://oauth2.googleapis.com/revoke', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `token=${encodeURIComponent(t)}`,
    });
  } catch {
    /* non-fatal */
  }
}
